import { resolveRoute } from 'vike/routing';

export function route(pageContext: { urlPathname: string }) {
  if (pageContext.urlPathname === '/support-chat') {
    return { routeParams: { chatId: 'me' } };
  }

  const result = resolveRoute('/support-chat/@chatId', pageContext.urlPathname);

  if (!result.match) {
    return false;
  }

  const { chatId } = result.routeParams;

  return { routeParams: { chatId } };
}
